module.exports = __webpack_public_path__ + "img/mobile_type_four.3a99ee13.png";